import { Box, Typography, Button, Grid, Paper } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import BusinessIcon from "@mui/icons-material/Business";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import Layout from "../components/layout/LandingPageLayout";
import {Link} from "react-router-dom"

const IntegrationInfo = () => {
  const theme = useTheme();

  return (
    <Layout>
      <Box
        sx={{
          py: 8,
          px: 4,
          backgroundColor: theme.palette.background.default,
        }}
      >
        {/* Section Title */}
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{ fontWeight: "bold", color: theme.palette.primary.main }}
        >
          Seamless Business Integration
        </Typography>

        <Typography
          variant="body1"
          align="center"
          sx={{
            maxWidth: 700,
            mx: "auto",
            color: theme.palette.text.secondary,
            mb: 6,
          }}
        >
          Our AI Accountant integrates effortlessly with your existing business
          systems, enabling smooth workflows, automated data sync, and better
          collaboration across your teams.
        </Typography>

        {/* Features Grid */}
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} sm={4}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                textAlign: "center",
                borderRadius: 3,
                transition: "0.3s",
                "&:hover": { transform: "translateY(-6px)", boxShadow: 6 },
              }}
            >
              <BusinessIcon
                sx={{ fontSize: 50, color: theme.palette.primary.main, mb: 2 }}
              />
              <Typography variant="h6" gutterBottom>
                Business Systems
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Integrate with ERP, CRM, and existing finance software without
                disrupting your current workflow.
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                textAlign: "center",
                borderRadius: 3,
                transition: "0.3s",
                "&:hover": { transform: "translateY(-6px)", boxShadow: 6 },
              }}
            >
              <CloudSyncIcon
                sx={{ fontSize: 50, color: theme.palette.primary.main, mb: 2 }}
              />
              <Typography variant="h6" gutterBottom>
                Data Sync
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Real-time synchronization with cloud platforms ensures your
                financial data is always up-to-date.
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                textAlign: "center",
                borderRadius: 3,
                transition: "0.3s",
                "&:hover": { transform: "translateY(-6px)", boxShadow: 6 },
              }}
            >
              <AccountTreeIcon
                sx={{ fontSize: 50, color: theme.palette.primary.main, mb: 2 }}
              />
              <Typography variant="h6" gutterBottom>
                Scalable Integration
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Adaptable integrations that grow with your business, from
                startups to enterprises.
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* CTA */}
        <Box textAlign="center" mt={6}>
          <Button
            component={Link}
            to="/login"
            variant="contained"
            size="large"
            sx={{
              backgroundColor: theme.palette.primary.main,
              "&:hover": { backgroundColor: theme.palette.primary.dark },
              px: 5,
              py: 1.5,
              borderRadius: 3,
            }}
          >
            Integrate Now
          </Button>
        </Box>
      </Box>
    </Layout>
  );
};

export default IntegrationInfo;
